import { render, staticRenderFns } from "./Physicalexamination.vue?vue&type=template&id=42e13754&scoped=true"
import script from "./Physicalexamination.vue?vue&type=script&lang=js"
export * from "./Physicalexamination.vue?vue&type=script&lang=js"
import style0 from "./Physicalexamination.vue?vue&type=style&index=0&id=42e13754&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e13754",
  null
  
)

export default component.exports